import { activeEmailRegex, activePhoneRegex, createRules, fullNameRegex } from "@hilma/forms";
import { isMobilePhone, isEmail, length } from "class-validator";

export const schoolSignUpAdminInfoRules = createRules({
	schoolAdminName: { required: true, regex: fullNameRegex, greaterThan: 2, smallerThan: 45 },
	schoolAdminPhone: { required: true, activeRegex: activePhoneRegex, classValidator: (value: string) => isMobilePhone(value, 'he-IL') && (new RegExp(/^\d+/)).test(value) && length(value, 10, 10) },
	schoolAdminEmail: { required: true, activeRegex: activeEmailRegex, classValidator: (value: string) => isEmail(value) },
})